export default {
    videos: 'Videos',
    data_consumed: 'Verbrauchte Daten (mb)',
    size: 'Größe (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'Es gibt keine Datei',
    text_upload_file: 'Beginnen Sie mit dem Hochladen einer neuen Datei.',
    upload: 'Hochladen',
    quota_label: 'Belegter Speicher',
    quota_of: '{used} von {limit}',
    quota_none: 'Dein Tarif enthält keinen Speicherplatz, daher kannst du keine Videos hochladen. Erweitere deinen Tarif, um sie hochzuladen.',
    quota_full: 'Der Speicher deines Tarifs ist voll. Leere den Papierkorb oder erweitere deinen Tarif, um weitere Videos hochzuladen.',
    quota_exceeded: 'Das Video ist {size} groß, in deinem Tarif sind nur noch {free} frei. Leere den Papierkorb oder erweitere deinen Tarif.',
}